@use '../../scss/utility';

:host {
  display: block;
  background: var(--wb-black);
  z-index: utility.$wb-z-index-header;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  --height: #{utility.wb-pixel-to-rem(76px)};
  --logo-size: #{utility.wb-pixel-to-rem(38px)};
  --logo-size-with-claim: #{utility.wb-pixel-to-rem(181px)};
}

.inner {
  width: var(--wb-grid-width);
  margin-inline-start: auto;
  margin-inline-end: auto;
  position: relative;

  @include utility.breakpoint-from(mq5) {
    display: flex;
  }
}

.logo-container {
  height: var(--height);
  overflow: hidden;

  @include utility.breakpoint-to(mq4) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.logo {
  z-index: 1;
  box-sizing: border-box;

  &:focus-visible {
    outline: utility.wb-pixel-to-rem(1px) solid var(--wb-blue-45);
  }

  @include utility.breakpoint-to(mq4) {
    padding: calc((var(--height) - var(--logo-size)) / 2);
    height: var(--height);
    width: var(--height);
  }

  @include utility.breakpoint-from(mq5) {
    position: absolute;
    line-height: 0;
    width: var(--logo-size-with-claim);
    inset-inline-start: 0;
    inset-block-start: calc((var(--height) - var(--logo-size)) / 2);
  }
}

.star {
  width: var(--logo-size);
  height: var(--logo-size);
}

.claim {
  display: none;
  width: utility.wb-pixel-to-rem(112px);
  color: var(--wb-white);
  position: absolute;
  inset-inline-end: 0;
  inset-block-end: utility.wb-pixel-to-rem(5px);

  @include utility.breakpoint-from(mq5) {
    display: block;
  }
}

.meta {
  @include utility.breakpoint-from(mq5) {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    height: var(--height);
    width: calc(100% - var(--logo-size-with-claim));
    padding: utility.wb-pixel-to-rem(24px) 0;
    margin-inline-start: auto;
    box-sizing: border-box;
  }
}

.desktop-meta {
  flex-direction: row;
  align-items: center;
}

.mobile-meta,
.tablet-meta {
  position: absolute;
  height: 100%;
  width: 100%;
  inset-block-start: 0;
  justify-content: space-between;
  align-items: center;
}

.row {
  display: flex;
  align-items: center;
}

.mobile-meta {
  display: flex;
}

.desktop-meta,
.tablet-meta {
  display: none;
}

@include utility.breakpoint-from(mq3) {
  .mobile-meta {
    display: none;
  }
  .tablet-meta {
    display: flex;
  }
}

@include utility.breakpoint-from(mq5) {
  .tablet-meta {
    display: none;
  }
  .desktop-meta {
    display: flex;
  }
}
